import React, {useEffect} from 'react';
import styled from '@emotion/styled';
import {useNavigate, useSearchParams} from "react-router-dom";
import {getStateValues, setStateValues, State} from "../../services/auth";
import {PublicLayout} from "../../containers/layouts/PublicLayout";

function Auth() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const idToken = searchParams.get("idToken");
    const refreshToken = searchParams.get("refreshToken");
    const expire = searchParams.get("expire");
    const stateParam = searchParams.get("state");
    if (idToken) {
      localStorage.setItem("idToken", idToken);
      localStorage.setItem("refreshToken", refreshToken ?? '');
      localStorage.setItem("expire", expire ?? "0");
    }
    let state = stateParam ? JSON.parse(atob(stateParam)) as State : getStateValues();
    if (!state.kfn || !state.fn || state.kfn.length === 0 || state.fn.length === 0) {
      state = getStateValues();
    }
    setStateValues(state);
    const { kfn, fn } = state;
    const params: string[] = [];
    kfn.filter(item => !!item && item.length > 0).forEach(item => params.push(`kfn=${item}`));
    fn.filter(item => !!item && item.length > 0).forEach(item => params.push(`fn=${item}`));
    navigate(`/?${params.join("&")}`);
  }, [navigate, searchParams]);

  return (
      <PublicLayout>
          <Header>
              <h4>Processing</h4>
          </Header>
      </PublicLayout>
  );
}

export default Auth;

const Header = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
